import { CMSApi } from 'api';
import { useEffect, useState } from 'react';
import { PolicyContentData } from '../components/PolicyContent/interface';

export default function usePolicyData(contentType: string) {
	const [seoData, setSeoData] = useState({} as PolicyContentData);

	const fetchDesc = async () => {
		try {
			const resp = await CMSApi.getSeoDescriptions(contentType);
			if (!resp.data.isError) {
				setSeoData(resp.data.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		fetchDesc();
	}, [contentType]);

	return seoData;
}
